/** @jsxRuntime classic */
/** @jsx jsx */
import { useState, useRef, useEffect } from "react";
import { jsx, Button, Input, Label } from "theme-ui";

import api, { errorMessage } from "../utils/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [sent, setSent] = useState(false);
  const inputRef = useRef();

  useEffect(() => {
    if (inputRef.current) inputRef.current.focus();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError(false);

    api
      .post("/api/password-reset/", { email: email.toLowerCase() })
      .then(() => {
        setLoading(false);
        setSent(true);
      })
      .catch((err) => {
        setLoading(false);
        setError(
          errorMessage(err, "We couldn't send that email. Please try again."),
        );
      });
  };

  if (sent) {
    return (
      <div sx={formSx}>
        <h1 sx={headingSx}>Check your inbox</h1>
        <p sx={{ lineHeight: 1.5 }}>
          If an account exists for <strong>{email.toLowerCase()}</strong>, we've
          sent it a link to choose a new password. It should arrive within a few
          minutes — do check your spam folder.
        </p>
        <div sx={{ fontSize: "90%", mt: 36, textAlign: "center" }}>
          <a sx={{ variant: "components.link", color: "red" }} href="/login">
            Back to login
          </a>
        </div>
      </div>
    );
  }

  return (
    <form sx={formSx} onSubmit={handleSubmit}>
      <h1 sx={headingSx}>Forgot password</h1>
      <p sx={{ lineHeight: 1.5, mb: 30 }}>
        Enter the email address you use for Planque and we'll send you a link to
        choose a new password.
      </p>
      {error && <div sx={errorSx}>{error}</div>}
      <Label htmlFor="email">Email</Label>
      <Input
        name="email"
        type="email"
        placeholder="your@email.com"
        required
        ref={inputRef}
        onChange={(e) => setEmail(e.target.value)}
      />
      <Button sx={{ width: "100%", my: 36 }} type="submit" disabled={loading}>
        {loading ? "Sending..." : "Send reset link"}
      </Button>
      <div sx={{ fontSize: "90%", textAlign: "center", color: "black" }}>
        Remembered it?{" "}
        <a sx={{ variant: "components.link", color: "red" }} href="/login">
          Back to login
        </a>
      </div>
    </form>
  );
}

const formSx = {
  width: "90%",
  maxWidth: 500,
  p: [10, 50],
  mx: "auto",
};

const headingSx = {
  textAlign: "left",
  my: 0,
  fontSize: 55,
  fontWeight: 300,
  fontFamily: "heading",
};

const errorSx = {
  backgroundColor: "error",
  color: "white",
  padding: 20,
  mb: 30,
  fontSize: 14,
};
